import { type Participant, type RemoteParticipant } from 'livekit-client';

export function isRemoteParticipant(participant: Participant | undefined | null): participant is RemoteParticipant {
    return !!participant?.identity?.startsWith('agent-');
}
